import LocalizedStrings from 'react-localization'

/* eslint-disable camelcase */
import en_us from './en_us'

export const lang = new LocalizedStrings({
  ...en_us
})




// WEBPACK FOOTER //
// ./src/il8n/lang.js